import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { JobCategoryBase } from '../../../types'
import { SelectionOptionPanel } from '../../atoms/SelectionOptionPanel'

type Props = {
  jobCategories: JobCategoryBase[]
  onClickOption: (jobCategory: JobCategoryBase) => void
}

export const JobCategorySelectionField: FC<Props> = ({ jobCategories, onClickOption }) => {
  const { t } = useTranslation(['search'])

  return (
    <div className={styles.container}>
      <div className={styles.selectItems}>
        {jobCategories?.map((jobCategory) => {
          return (
            <SelectionOptionPanel
              key={jobCategory.id}
              name={jobCategory.name}
              onClick={() => onClickOption(jobCategory)}
              imageStyleType='none'
            />
          )
        })}
      </div>
      {jobCategories.length === 0 && <p className={styles.noContent}>{t('該当の職種が見つかりません')}</p>}
    </div>
  )
}
